module.exports = "img/flags/HK.c14d3f7.png";